module.exports = __webpack_public_path__ + "img/keyvisual-trikotaktion.c766d958.jpg";